import { api } from '@api'
import { useQuery } from '@tanstack/react-query'
import { ColorLabel } from './usePaginateColorLabels'

interface GetColorLabelByIdResponse {
  colorLabel: ColorLabel
}

const fetchColorLabelById = async (id: string): Promise<ColorLabel> => {
  const { data } = await api.get<GetColorLabelByIdResponse>(`/color-labels/${id}`)
  return data.colorLabel
}

export const useGetColorLabelById = (id: string) => {
  return useQuery<ColorLabel>({
    queryKey: ['color-label', id],
    queryFn: () => fetchColorLabelById(id),
    enabled: !!id,
  })
}

